import React from 'react';

import { FocusContext, setFocus, useFocusable } from '@noriginmedia/norigin-spatial-navigation';

import styles from './player-devices-dialog.module.scss';

import PlayerDevicesDialogEditScreenDevices from './player-devices-dialog-edit-screen-devices';
import PlayerDevicesDialogEditScreenFooter from './player-devices-dialog-edit-screen-footer';
import PlayerDevicesDialogEditScreenHeader from './player-devices-dialog-edit-screen-header';

export const PlayerDevicesDialogEditScreen: React.FC = () => {
  const { ref, focusSelf, focusKey } = useFocusable({ isFocusBoundary: true });

  React.useEffect(() => {
    focusSelf();
  }, [focusSelf]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className={styles['player-devices-dialog-edit-screen']}>
        <PlayerDevicesDialogEditScreenHeader />

        <PlayerDevicesDialogEditScreenDevices />

        <PlayerDevicesDialogEditScreenFooter setFocus={setFocus} />
      </div>
    </FocusContext.Provider>
  );
};

export default PlayerDevicesDialogEditScreen;
